<template>
  <div class="d-flex flex-row">
    <div v-if="loading" class="loading">
      <div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <template v-else>
      <admin-nav></admin-nav>
      <div class="d-flex flex-column flex-grow-1">
        <admin-header></admin-header>
        <div class="admin-content">
          <router-view></router-view>
        </div>
      </div>
    </template>
    <c-notification-container></c-notification-container>
  </div>
</template>

<script>
import adminService from "@/services/adminService.js";

import AdminNav from "@/components/AdminNav.vue";
import AdminHeader from "@/components/AdminHeader.vue";
import CNotificationContainer from "@/components/CNotificationContainer.vue";

export default {
  name: "Admin",
  data() {
    return {
      loading: true
    };
  },
  components: {
    AdminNav,
    AdminHeader,
    CNotificationContainer
  },
  methods: {
    validateAdmin() {
      adminService
        .getCurrentAdmin()
        .then(() => {
          this.loading = false;
        })
        .catch(err => {
          if (err.response.status == 401) {
            this.$router.push({ name: "login" });
          }
        });
    }
  },
  mounted() {
    this.validateAdmin();
  }
};
</script>

<style>
.loading {
  z-index: 999;
  position: fixed;
  width: 100%;
  height: 100%;
  background: #34495e;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading > div {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.loading > div div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: spinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}

.loading > div div:nth-child(1) {
  animation-delay: -0.45s;
}

.loading > div div:nth-child(2) {
  animation-delay: -0.3s;
}

.loading > div div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.admin-content {
  padding: 15px;
  width: 100%;
  box-sizing: border-box;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
</style>
